import { BSection } from "../../style/main/main";
import MainData from "../../view/main/main.data.json";

const BottomSection = () => {
  const data = MainData.featureBlocks;
  return (
    <BSection>
      <div className="inner">
        {data.map((item, index) => (
          <div key={index} className="item-box">
            <div className="top">
              <div className="img-box">
                <img src={item.icon} alt={item.icon} />
              </div>
              <h3 className="title">{item.title}</h3>
            </div>
            <ul className="list-box">
              {item.bullets.map((line, i) => (
                <li key={i}>- {line}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="bg-logo-section">
        <span className="icon-box">
          <img src="/assets/logo.png" alt="" />
        </span>
        <span className="img-box">
          <img src="/assets/logo_txt.png" alt="" />
        </span>
      </div>
    </BSection>
  );
};

export default BottomSection;
